module.exports = __webpack_public_path__ + "static/img/warehouse2.8f0e091.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mainpage/warehouse2.png
// module id = 2nsY
// module chunks = 18